<div class="cgs support4" [ngClass]="support?.exam?.level">
  <div *ngIf="support">
    <div *ngIf="support?.training_audio">
      <!--
        <cf-player-audio  song-id="support.id" file="support.training_audio" audioscript="support.text" can-show-audio-script="finished" can-play="true" mode="'single'"></cf-player-audio>
      -->
    </div>

    <div>
      <p *ngIf="support.part === 7">
        <b>Vous dégagerez le problème soulevé par le document ci-dessous.</b
        ><br />Vous présenterez votre opinion sur le sujet de manière argumentée
        et vous la défendrez si nécessaire.
      </p>

      <p
        *ngIf="support.instructions"
        [innerHTML]="support.instructions | safe: 'html'"
      ></p>

      <p
        *ngIf="support?.text?.length"
        class="md-title cgs"
        [innerHTML]="support.text"
      ></p>

      <img
        *ngIf="support?.image"
        [src]="support.image"
        class="img-responsive-100"
      />

      <div>
        <div
          *ngFor="let question of support?.questions; let index = index"
          required
        >
          <span class="md-subhead" *ngIf="exam || buildup"
            >Question {{ index }}</span
          >
          <p *ngIf="question?.text?.length">
            <b>{{ question.text }}</b>
          </p>

          <!--
            <textarea rows="6" class="custom-input" *ngIf="!finished" spellcheck="false" autocomplete="off" ng-disabled="finished" ng-model="userAnswersInput[question.id]" ng-blur="exam && question.choice_user ? saveAnswer(question.choice_user, support, userAnswersInput[question.id]) : null" ng-change="checkedOpenGapAnswer(question, userAnswersInput[question.id])" placeholder="Votre réponse"></textarea>
            <div *ngIf="finished" class="custom-input" style="display: inline-block;width: 80%;">
            <span *ngIf="!finished || (finished && (choice.is_correct || question.choice_user === choice.id))" ng-repeat="choice in support.questions[1].choices | reverse">
              <span *ngIf="choice.is_correct" class="text-success">

                <span *ngIf="question.choice_user === choice.id">
                  {{userAnswersInput[question.id]}}
                </span>
                <span *ngIf="question.choice_user !== choice.id">
                  {{(choice.text | showFirstAnswer)}}
                </span>

              </span>
              <span style="margin-right: 12px; text-decoration: line-through;" class="text-fail" *ngIf="choice.is_correct === false && userAnswersInput[question.id]">
                {{choice.extra_value || userAnswersInput[question.id]}}
              </span>
            </span>
          </div>
          -->
          <br />
        </div>
      </div>
    </div>
  </div>

  <div></div>
</div>
